module.exports = __webpack_public_path__ + "static/media/logo-sensa.419aa49d.svg";